import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ru from './locales/ru.json'

/**
 * i18n панели (docs/10 §8, NFR-12): русский — язык по умолчанию, английский —
 * прямой перевод без сленга. Хардкода строк в компонентах нет: всё через ключи.
 */

export const SUPPORTED_LOCALES = ['ru', 'en'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'ru'

const STORAGE_KEY = 'apiary.locale'

/** Ресурсы вынесены отдельно: тесты собирают свой инстанс i18next из них же. */
export const resources = {
  ru: { translation: ru },
  en: { translation: en }
} as const

function isLocale(value: string | null): value is Locale {
  return value !== null && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

/** Язык из localStorage → из браузера → ru. */
export function detectLocale(): Locale {
  try {
    const stored = globalThis.localStorage?.getItem(STORAGE_KEY) ?? null
    if (isLocale(stored)) return stored
  } catch {
    // приватный режим может запрещать localStorage — не повод падать
  }
  const navigatorLang = globalThis.navigator?.language?.slice(0, 2) ?? ''
  return isLocale(navigatorLang) ? navigatorLang : DEFAULT_LOCALE
}

export async function setLocale(locale: Locale): Promise<void> {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, locale)
  } catch {
    // см. выше
  }
  document.documentElement.lang = locale
  await i18n.changeLanguage(locale)
}

let initialized = false

export function initI18n(locale: Locale = detectLocale()): typeof i18n {
  if (initialized) return i18n
  initialized = true
  void i18n.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: { escapeValue: false },
    returnNull: false
  })
  return i18n
}

export { i18n }
